export default __webpack_public_path__ + "static/cart-animation-fc42616d1674499cdf7d612bad70d065.gif";